import React from 'react';

import DashboardStyles from './../../styles/DashboardStyles';

const Moved = () => {
  return (
    <>
      <div className="Dashboard Pending Moved">
        <div className="container container-full">
          <div className="row">
            <div className="col s12">
              <h2 className="title">Important: your fund is moving to Algoforce</h2>
              <p>
                The fund is moving to Algoforce, so balance information is no longer available on this portal. We sent you an email a few days ago with the full details of the change.
              </p>
              <p>
                If you need your current balance or have any other questions, please email <a href="mailto:dc@fam-asset.com" className="link">dc@fam-asset.com</a>.
              </p>
              <p>
                Your investment is not affected by the move. We will contact you separately with your new Algoforce login details.
              </p>
              <p>
                Please note: we will never ask for your password, or ask you to transfer funds, by email.
              </p>
            </div>
          </div>
        </div>
      </div>
      <DashboardStyles/>
      <style>{`
        .Dashboard {
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default Moved;
